import BaseResource from './index'
import UserResource from './user'
import RankedRaceResource from './rankedrace'

export default class RaceResultResource extends BaseResource {
    static endpoint = '/races'

    static related() {
        return {
            user: UserResource,
            race: RankedRaceResource
        }
    }

    toString() {
        return this.get('display_name') || ''
    }
}
